/* istanbul ignore file */
import { createSelector } from 'reselect'

export const ratesSelector = (state) => state.rates

export const ratesDataSelector = createSelector(
    ratesSelector,
    (rates) => rates.data
)

export const ratesFiltersConfigSelector = createSelector(
    ratesDataSelector,
    (data) => data.filtersConfig
)

export const vehicleListSelector = createSelector(
    ratesDataSelector,
    (data) => data.vehicles
)

export const ratesRateListSelector = createSelector(
    ratesDataSelector,
    (data) => data.ratesList
)

export const ratesStatusSelector = createSelector(
    ratesSelector,
    (rates) => rates.status
)

export const ratesErrorSelector = createSelector(
    ratesStatusSelector,
    (status) => status.error
)

export const ratesIsLoadingSelector = createSelector(
    ratesStatusSelector,
    (status) => status.pending
)

export const ratesIsAvailableSelector = createSelector(
    ratesDataSelector,
    (rates) => !!rates
)
